import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const ProtectedRoute = ({ children, roles, loginPath }) => {
  const location = useLocation();
  const { user, isAuthenticated, isSessionRestored } = useSelector(state => state.auth);

  if (!isSessionRestored) {
    return <div role="status" className="page-loader">Restoring your session…</div>;
  }
  if (!isAuthenticated || !roles.includes(user?.role)) {
    return <Navigate to={loginPath} replace state={{ returnTo: `${location.pathname}${location.search}` }} />;
  }
  return children;
};